import React from 'react';

interface Props {
    fullName: string;
    companyName?: string | null | undefined;
    email?: string;
}

const CurrentUser = (props: Props) => {
    const { fullName, companyName, email } = props;

    return (
        <>
            <span className="font-weight-bold">{`${fullName}`}</span>

            {email ? (
                <>
                    <br />
                    {email}
                </>
            ) : null}
        </>
    );
};

export default CurrentUser;
